"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuSelectItem = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_icon_1 = require("@hopin-team/ui-icon");

var ui_text_1 = require("@hopin-team/ui-text");

var react_1 = tslib_1.__importStar(require("react"));

var context_1 = require("../context");

var select_item_1 = require("../styled/select-item");

var TRIGGER_KEYS = ['Enter', ' '];

var MenuSelectItem = function MenuSelectItem(_a) {
  var __UIScope = _a.__UIScope,
      testID = _a["data-testid"],
      className = _a.className,
      avatar = _a.avatar,
      logo = _a.logo,
      media = _a.media,
      label = _a.label,
      leadingIcon = _a.leadingIcon,
      onClick = _a.onClick,
      _b = _a.role,
      role = _b === void 0 ? 'menuitem' : _b,
      trailingIcon = _a.trailingIcon,
      iconColorFromProps = _a.iconColor,
      disabled = _a.disabled,
      subtext = _a.subtext;
  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'MenuSelectItem',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;

  var _c = (0, react_1.useContext)(context_1.MenuContext),
      onItemSelected = _c.onItemSelected,
      isInverse = _c.isInverse;

  var avatarComponent = avatar && (subtext ? (0, react_1.cloneElement)(avatar, {
    size: 'medium',
    alt: ''
  }) : (0, react_1.cloneElement)(avatar, {
    size: 'tiny',
    alt: ''
  }));

  var clickHandler = function clickHandler(e) {
    if (!disabled) {
      onClick === null || onClick === void 0 ? void 0 : onClick(e);
      onItemSelected === null || onItemSelected === void 0 ? void 0 : onItemSelected();
    }
  };

  var iconColor = (0, react_1.useMemo)(function () {
    if (disabled) return isInverse ? 'grey-400' : 'grey-600';
    return iconColorFromProps || (isInverse ? 'grey-white' : 'grey-dark');
  }, [disabled, iconColorFromProps, isInverse]);
  return react_1.default.createElement(select_item_1.SelectItem, {
    className: rootClasses,
    "data-testid": testID,
    role: role,
    onClick: clickHandler,
    tabIndex: -1,
    isInverse: isInverse,
    onKeyDown: function onKeyDown(e) {
      if (TRIGGER_KEYS.includes(e.key) && !disabled) {
        clickHandler(e);
      }
    },
    "aria-disabled": !!disabled
  }, leadingIcon && react_1.default.createElement(ui_icon_1.Icon, {
    name: leadingIcon,
    title: leadingIcon,
    "aria-hidden": true,
    color: iconColor
  }), (avatar || logo || media) && react_1.default.createElement(select_item_1.Decorator, {
    hasAvatar: Boolean(avatar),
    hasLogo: Boolean(logo),
    hasMedia: Boolean(media),
    hasSubtext: Boolean(subtext)
  }, avatarComponent || logo || media), react_1.default.createElement(select_item_1.Content, {
    flexDirection: (subtext === null || subtext === void 0 ? void 0 : subtext.position) === 'right' ? 'row' : 'column',
    justifyContent: (subtext === null || subtext === void 0 ? void 0 : subtext.position) === 'right' ? 'space-between' : 'flex-start'
  }, label, (subtext === null || subtext === void 0 ? void 0 : subtext.label) && react_1.default.createElement(ui_text_1.Text, {
    pattern: (subtext === null || subtext === void 0 ? void 0 : subtext.position) === 'bottom' ? 'caption' : 'body',
    color: isInverse ? 'grey-white' : 'grey-medium',
    ml: (subtext === null || subtext === void 0 ? void 0 : subtext.position) === 'right' ? 1.5 : 0
  }, subtext === null || subtext === void 0 ? void 0 : subtext.label)), trailingIcon && react_1.default.createElement(ui_icon_1.Icon, {
    name: trailingIcon,
    title: trailingIcon,
    "aria-hidden": true,
    color: iconColor
  }));
};

var MenuSelectItemWithSpace = (0, ui_helper_with_space_1.withSpace)(MenuSelectItem);
exports.MenuSelectItem = MenuSelectItemWithSpace;